module.exports = __webpack_public_path__ + "img/2374782-07-5.622cddd1.png";